import { useSelector, useDispatch } from "react-redux"
import { makeStyles } from '@material-ui/core/styles'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import { obtenerPeticionesDevolucionesReferenciaAction, obtenerPeticionesFacturasReferenciaAction } from "../../../ducks/clientesDuck"
import { useEffect } from "react"
import { Alert } from "@material-ui/lab"
import DialogMensaje from "../../Devoluciones/TDevoluciones/DialogMensaje"
import ButtonDowloadEstadoCueta from "../../Devoluciones/TDevoluciones/ButtonDowloadEstadoCueta"

const useStyles = makeStyles({
    table: {
        minWidth: 650,
    },
});
const VDevoluciones = () => {
    const { devoluciones, cliente, referencia } = useSelector(store => store.cliente)
    const classes = useStyles()
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(obtenerPeticionesDevolucionesReferenciaAction({ referencia: referencia }))
    }, [dispatch, referencia])

    if (!referencia) return (
        <Alert className="alerta" severity="info">Seleccione un cliente</Alert>
    )
    return (
        <div>
            <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center">Nombre</TableCell>
                            <TableCell align="center">Motivo</TableCell>
                            <TableCell align="center">Estatus</TableCell>
                            <TableCell align="center">Banco</TableCell>
                            <TableCell align="center">CLABE</TableCell>
                            <TableCell align="center">RFC</TableCell>
                            <TableCell align="center">Docuemento</TableCell>
                            <TableCell align="center">Motivo</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {devoluciones.map((row, index) => (
                            <TableRow key={row.IdDevolucionSolicitud}>
                                <TableCell align='center'>
                                    {`${row?.Nombre} ${row?.Apellidos}`}
                                </TableCell>
                                <TableCell align='center'>
                                    {row?.CatDevolucion?.Descripcion}
                                </TableCell>
                                <TableCell align='center'>
                                    {row?.CatEstatusDevolucion?.Descripcion}
                                </TableCell>
                                <TableCell align="center">
                                    {row?.Banco?.Nombre}
                                </TableCell>
                                <TableCell align="center">
                                    {`${row?.CuentaClave}`}
                                </TableCell>
                                <TableCell align="center">
                                    {`${row?.RFC}`}
                                </TableCell>
                                <TableCell align="center">
                                    <ButtonDowloadEstadoCueta
                                        IdDevolucionSolicitud={row?.IdDevolucionSolicitud}
                                    />
                                </TableCell>
                                <TableCell align="center">
                                    <DialogMensaje Mensaje={row?.Motivo} />
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </div>
    )
}
export default VDevoluciones